import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:8001";
export const API = `${BACKEND_URL}/api/v1`;

const api = axios.create({ baseURL: API, withCredentials: true });

export default api;

export const INR = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const photoUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  return `${API}/files/${path}`;
};
